import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as Search } from './search.svg'
import style from './style.module.scss'
import i18next from 'i18next'

const getLanguage = () => i18next.language || window.localStorage.i18nextLng

const SearchMainHeader = () => {
    const { t } = useTranslation()
    const [search, setSearch] = useState('')

    const handleChange = (e) => {
        setSearch(e.target.value)
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if (search) {
            window.location.href = `/${getLanguage() === 'en' ? 'en' : ''}?s=${search}`
        }
    }

    return (
        <div className={style.search}>
            <form onSubmit={handleSubmit}>
                <input
                    type={'text'}
                    placeholder={`${t('Rechercher')}...`}
                    value={search}
                    onChange={handleChange}
                />
                <button type={'submit'}>
                    <Search />
                </button>
            </form>
        </div>
    )
}

export default SearchMainHeader
